import { Component, OnInit, Inject, Injector } from '@angular/core';
import { DialogConfig, DialogService } from '@tmhcc-ng-lib/framwork/dialog';
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators
} from '@angular/forms';
import { MustMatch, ValidatePassword } from './must-match.validator';
import {
  FormValidatorService,
  ResetPasswordService
} from '@tmhcc-ng-lib/content-service';
import { OktaConfig } from '@okta/okta-angular';
import { OKTA_CONFIG } from '@okta/okta-angular';
import { resetPasswordType } from '@tmhcc-ng-lib/data-service';
import {
  FetchDataService,
  FormGenerator,
  FormMap
} from '@tmhcc-ng-lib/framwork/form-generator';
import { AlertTosterService } from '@tmhcc/framwork/alert-toster';
import { OktaLoginService } from '@tmhcc-ng-lib/okta-service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'ae-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  resetPassword: FormGroup;
  data: FormMap;
  mainForm: FormGroup;
  submitted = false;
  password;
  resetPassContent;
  isDataAvailable: boolean = false;
  formFields: any = {};
  sessionId: string;
  status: string = '';

  constructor(
    public dialogData: DialogConfig,
    private fb: FormBuilder,
    public dialogService: DialogService,
    private resetPasswordService: ResetPasswordService,
    @Inject(OKTA_CONFIG) protected config: OktaConfig,
    private oktaLoginService: OktaLoginService,
    private injector: Injector,
    private dataFetchService: FetchDataService,
    private formValidatorService: FormValidatorService,
    private activatedRoute: ActivatedRoute
  ) {
    this.activatedRoute.queryParams.subscribe(params => {
      // console.log(params);
      this.sessionId = params['reset'].substring(
        params['reset'].indexOf('=') + 1
      );
    });
  }

  ngOnInit(): void {
    this.resetPassword = this.fb.group(
      {
        password: [''],
        confirmPassword: ['']
      },
      {
        validator: [
          this.formValidatorService.mustMatch('password', 'confirmPassword'),
          this.formValidatorService.validatePassword('password')
        ]
      }
    );

    this.resetPasswordService.data$.subscribe(res => {
      this.resetPassData(res);

      this.formFields.passwordField = this.fetchFormFields(
        res.forms[0].fields,
        'Password'
      );
      this.formFields.confirmPasswordField = this.fetchFormFields(
        res.forms[0].fields,
        'Confirm Password'
      );

      const passwordValidations = this.formValidatorService.setFormValidator(
        this.formFields.passwordField
      );
      const confirmPasswordValidations = this.formValidatorService.setFormValidator(
        this.formFields.confirmPasswordField
      );
      this.f.confirmPassword.setValidators(confirmPasswordValidations);

      this.resetPassword.get('password').setValidators(passwordValidations);
      this.resetPassword.get('password').updateValueAndValidity();

      this.f.password['requiredError'] = this.fetchValidationValue(
        this.formFields.passwordField.fieldInfo.validations,
        'Required'
      ).value;
      this.f.password['minLengthError'] = this.fetchValidationValue(
        this.formFields.passwordField.fieldInfo.validations,
        'PasswordMinLength'
      ).value;
      this.f.password['maxLengthError'] = this.fetchValidationValue(
        this.formFields.passwordField.fieldInfo.validations,
        'PasswordMaxLength'
      ).value;
      this.f.password['passwordEmailError'] = this.fetchValidationValue(
        this.formFields.passwordField.fieldInfo.validations,
        'PasswordEmail'
      ).value;
      this.f.password['passwordFormatError'] = this.fetchValidationValue(
        this.formFields.passwordField.fieldInfo.validations,
        'PasswordFormat'
      ).value;
      this.f.password['passwordUserNameError'] = this.fetchValidationValue(
        this.formFields.passwordField.fieldInfo.validations,
        'PasswordUserName'
      ).value;

      this.f.confirmPassword['matchError'] = this.fetchValidationValue(
        this.formFields.confirmPasswordField.fieldInfo.validations,
        'ConfirmPasswordMatch'
      ).value;
      this.f.confirmPassword['requiredError'] = this.fetchValidationValue(
        this.formFields.confirmPasswordField.fieldInfo.validations,
        'Required'
      ).value;
    });
  }
  fetchValidationValue(validations: any[], key: string) {
    const filterObj = validations.filter(ele => ele.key == key);
    if (filterObj.length) return filterObj[0];
    return filterObj;
  }

  fetchFormFields(fields: any[], label: string) {
    const filterObj = fields.filter(ele => ele.fieldInfo.label == label);
    if (filterObj.length) return filterObj[0];
    return filterObj;
  }

  resetPassData(data) {
    if (data) {
      this.resetPassContent = data;
      this.isDataAvailable = true;
      this.dialogData.modalSetting.title = this.resetPassContent.data[0].title;
    }
  }
  get f() {
    return this.resetPassword.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this.resetPassword.invalid) {
      return;
    } else {
      const dataCall: resetPasswordType = {
        SessionID: this.sessionId,
        Password: this.resetPassword.value.password
        //confirmPassword: this.resetPassword.value.confirmPassword
      };

      if (
        this.resetPassword.value.password ==
        this.resetPassword.value.confirmPassword
      ) {
        this.oktaLoginService.resetPassword(dataCall).subscribe(res => {
          console.log('Reset Password Result = ' + res);
          if (res && res.Status == 'SUCCESS') {
            console.log('Reset Password Succeeded');
            this.status = 'Success';
            // this.dialogService.close();
            // const notifier = this.injector.get(AlertTosterService);
            // notifier.success('Reset Password request submitted');
          } else {
            this.status = 'Failure';
            console.log('Reset Password Failed');
          }
        });
        // this.dialogService.close();

        // this.dialogService.close();
        // const notifier = this.injector.get(AlertTosterService);
        // notifier.success('Reset Password request submitted');
      }
    }
  }

  cancel() {
    this.dialogService.close();
  }
}
